<template>
    <v-dialog v-model="dialog" persistent max-width="800" :fullscreen="testCalculation">
        <v-card v-if="dialog">
            <v-card-title class="primary white--text title">
                <span v-if="activeItem.sensor_id">{{ 'Edit Point'|translate }}</span>
                <span v-if="!activeItem.sensor_id">{{ 'Add Point'|translate }}</span>
            </v-card-title>
            <v-layout row>
                <v-flex v-bind:class="[testCalculation ? 'xs4' : 'xs12']">
                    <v-card-text>
                        <v-text-field :label="'Sensor Name'|translate" autofocus
                                      v-model="activeItem.sensor_name"></v-text-field>
                        <v-text-field :label="'Sensor Name Abbr'|translate" autofocus
                                      v-model="activeItem.sensor_name_abbr"></v-text-field>
                        <v-text-field :label="'Sensor Desc'|translate" autofocus
                                      v-model="activeItem.sensor_desc"></v-text-field>
                        <v-text-field :label="'Unit'|translate" autofocus v-model="activeItem.unit"></v-text-field>
                        <v-switch color="success" v-model="activeItem.faulty" :label="'Faulty'|translate"></v-switch>
                        <v-textarea clearable :label="'Faulty State Change Note'|translate" v-if="activeItem.sensor_id&&activeItem.faulty!==faultyInitialState" v-model="faultyNote"></v-textarea>
                        <connector-selector clearable label="Connector" v-model="activeItem.connector_id"
                                            v-if="!activeItem.calculations_statement||activeItem.calculations_statement==''"></connector-selector>
                        <v-text-field clearable label="Upstream ID" v-model="activeItem.haystack_id"
                                      v-if="!activeItem.calculations_statement||activeItem.calculations_statement==''||(activeItem.haystack_id&&activeItem.haystack_id!=='')"></v-text-field>
                        <v-textarea clearable label="Calculation Statement"
                                    v-if="!activeItem.haystack_id||activeItem.haystack_id===''||activeItem.haystack_id==='null'||activeItem.haystack_id==='NaN'"
                                    v-model="activeItem.calculations_statement">
                            <template slot="append">
                                <v-icon class="cursor-as-pointer" @click="secondaryDialog=true">fa-plus</v-icon>
                                <v-icon class="cursor-as-pointer ml-2"
                                        v-if="activeItem.calculations_statement&&activeItem.calculations_statement!==''"
                                        @click="showCalculation">fa-chart-line
                                </v-icon>
                            </template>
                        </v-textarea>
                        <v-alert v-if="error"
                                 :value="true"
                                 type="error"
                        >
                            {{ error }}
                        </v-alert>
                        <v-dialog v-model="secondaryDialog" max-width="400">
                            <v-card>
                                <v-card-title class="secondary">Add sensor to calculation</v-card-title>
                                <v-card-text class="pt-5">
                                    <sensor-selector v-model="selectedSensor"></sensor-selector>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn class="secondary" :disabled="!selectedSensor" @click="addSelectedSensor()">
                                        Add
                                    </v-btn>
                                    <v-btn @click="secondaryDialog=false;selectedSensor=null">Cancel</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-text-field :label="'Weight'|translate" type="number" autofocus
                                      v-model.number="activeItem.weight"></v-text-field>
                        <v-text-field :label="'Facility Name'|translate" autofocus v-model="activeItem.facility_name"
                                      disabled></v-text-field>
                        <equipment-selector v-model="activeItem.equipment_name"></equipment-selector>
                        <label>Meta</label>
                        <editor v-model="activeItem.meta" @init="editorInit" lang="json" theme="twilight" width="100%"
                                height="500"></editor>
                    </v-card-text>
                </v-flex>
                <v-flex xs8 v-if="testCalculation">
                    <v-layout row class="mt-3">
                        <date-range-selector v-model="dateRange"></date-range-selector>
                        <v-btn class="primary" @click="showCalculation">{{ 'Refresh'|translate }}</v-btn>
                        <v-btn class="primary" @click="testCalculation=false">{{ 'Close'|translate }}</v-btn>
                    </v-layout>

                    <data3-chart
                        :layout-overrides="calcLayout"
                        :on-only="false"
                        :x-axis="'timestamp'"
                        show-units
                        show-errors
                        resolve-ids-to-name
                        disable-responsive
                        :data-payload="calcPayload"
                        :date-range="dateRange"></data3-chart>
                </v-flex>
            </v-layout>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outline class="mr-2" @click="initializeVar(true)">{{ 'Cancel'|translate }}</v-btn>
                <v-btn class="primary mr-2 elevation-4" @click="addRecord(true)" :disabled="!$can('update', 'Points')">
                    {{ 'Save'|translate }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import EquipmentSelector from '../EquipmentSelector'
import DateRangeSelector from "../DateRangeSelector";
import SensorSelector from "@/components/SensorSelector";
import Data3Chart from "@/components/Data3Chart";
import ConnectorSelector from "@/components/ConnectorSelector";
import {putPoint} from '../../helper'
import editor from 'vue2-ace-editor'
import moment from "moment";

export default {
    components: {ConnectorSelector, EquipmentSelector, SensorSelector, DateRangeSelector, Data3Chart, editor},
    props: {
        value: {type: Boolean, default: true},
        item: {type: Object, default: null}
    },
    watch: {
        item(item) {
            this.reactToItem(item)
        },
        value() {
            if (!this.activeItem.sensor_id && !this.activeItem.equipment_name && !(this.activeItem.haystack_id && this.activeItem.haystack_id !== "")) {
                this.initializeVar()
            }
            if (!this.activeItem.sensor_id && this.item && this.item.sensor_id) {
                this.reactToItem(this.item)
            }
            if (this.dialog != this.value) {
                this.dialog = this.value
                //this.initializeVar()
            }
        },
        dialog() {
            this.$emit('input', this.dialog)
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            faultyInitialState: false,
            sensorList: [],
            error: null,
            secondaryDialog: false,
            testCalculation: false,
            calcPayload: null,
            faultyNote: null,
            calcLayout: {
                title: "",
                colorway: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
                xaxis: {
                    title: "Time"
                },
                yaxis: {
                    title: ""
                },
                zaxis: {
                    title: null
                },
                showlegend: true,
                height: 500,
                hovermode: "x",
                margin: {
                    l: 50,
                    r: 50,
                    t: 50,
                    pad: 1
                },
                legend: {
                    orientation: 'h',
                    y: -0.3
                },
            },
            selectedSensor: null,
            dateRange: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
            activeItem: {
                sensor_id: null,
                connector_id: null,
                sensor_name: '',
                sensor_name_abbr: '',
                sensor_desc: '',
                unit: '',
                faulty: false,
                weight: 1,
                haystack_id: '',
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                equipment_name: null,
                meta: '',
            },
        }
    },
    beforeMount() {
        this.sensorList = this.$store.state.pointsListStore.pointsList.points_list.map((x) => {
            return {id: x.sensor_id, name: x.equipment_name + " - " + x.sensor_name}
        })
        let maxDate = this.$store.state.pointsListStore.pointsList.data_max_date;
        if (maxDate) {
            this.dateRange = {
                start: moment(maxDate).subtract(30, "days").format('YYYY-MM-DD'),
                end: moment(maxDate).format('YYYY-MM-DD')
            }
        }
    },
    mounted() {
        this.reactToItem(this.item)
    },
    methods: {
        editorInit: function () {
            require('brace/ext/language_tools')
            require('brace/mode/json')
            require('brace/theme/twilight')
        },
        reactToItem(item) {
            this.loading = true
            this.initializeVar()
            if (item) {
                let newItem = JSON.parse(JSON.stringify(item))
                if (newItem.calculations_statement && newItem.calculations_statement !== "") {
                    let tbr = newItem.calculations_statement.match(/df\[(.*?)\]/g)
                    if (tbr) {
                        for (let item of tbr) {
                            if (item.includes("get_ids_by_ref")) {
                                let bearer = item.split(',')[0].split("(")
                                let equipmentId = parseInt(bearer[bearer.length - 1])
                                let foundEquipment = Object.values(this.$store.state.pointsListStore.pointsList.equipment_details).filter(x => x.equipment_id === equipmentId)
                                if (foundEquipment.length > 0) {
                                    let fixedItem = item.replace(equipmentId, '"' + foundEquipment[0].equipment_name + '"')
                                    newItem.calculations_statement = newItem.calculations_statement.replace(item, fixedItem)
                                }
                            } else if (item.startsWith('df[[')) {
                                let itemCenters = item.split('[[')[1].split(']')[0].split(',')
                                let newCenters = []
                                for (let itemCenter of itemCenters) {
                                    let foundBearer = this.sensorList.filter(x => x.id == itemCenter)[0]
                                    if (foundBearer) {
                                        newCenters.push('"' + foundBearer.name + '"')
                                    }
                                }
                                if (itemCenters.length === newCenters.length) {
                                    newItem.calculations_statement = newItem.calculations_statement.replace(item, 'df[[' + newCenters.join(',') + ']')
                                }
                            } else {
                                let itemCenter = item.split('[')[1].split(']')[0]
                                let foundBearer = this.sensorList.filter(x => x.id == itemCenter)[0]
                                if (foundBearer) {
                                    newItem.calculations_statement = newItem.calculations_statement.replace(item, 'df["' + foundBearer.name + '"]')
                                }
                            }
                        }
                    }
                }
                newItem["meta"] = newItem['meta'] && newItem['meta'] !== "" ? JSON.stringify(newItem['meta']) : newItem['meta']
                this.activeItem = newItem
                this.faultyInitialState = newItem.faulty
                this.loading = false
            }
        },
        showCalculation() {
            this.testCalculation = false
            if (this.activeItem.calculations_statement && this.activeItem.calculations_statement !== "") {
                let tbr = [...new Set(this.activeItem.calculations_statement.match(/df\[(.*?)\]/g))]
                let first = true
                let payload = {
                    "filters": {
                        "sensor_name": null,
                    },
                    "seriesOverrides": {
                        "customUnit": null
                    },
                    "pipeline": [],
                    "offsetRange": false,
                    "onOnly": false
                }
                if (tbr) {
                    for (let item of tbr) {
                        if (item.includes("get_ids_by_ref")) {
                            let itemCenter = item.split('"')[1]
                            let equipName = itemCenter.split(" - ")[0]
                            let refName = item.split('"')[3]
                            let sensor_name = item.split('"')[5]
                            let child_name = item.split('"')[7]
                            if (first) {
                                payload.filters.equipment_name = equipName
                                delete (payload.filters.sensor_name)
                            }
                            let pipelineStage = {
                                "type": "insert_series_by_ref",
                                "ref_type": refName,
                                "sensor_name": sensor_name,
                                "remove_others": first,
                                "insert_as_ids": true
                            }
                            if (child_name) {
                                pipelineStage["equipment_type"] = child_name
                            }
                            payload.pipeline.push(pipelineStage)
                            first = false
                        } else if (item.startsWith('df[[')) {
                            let itemCenters = item.split('[[')[1].split(']')[0].split(',')
                            for (let itemCenterShell of itemCenters) {
                                let itemCenter = itemCenterShell.split('"')[1]
                                if (itemCenter) {
                                    if (first) {
                                        payload.filters.sensor_name = itemCenter.split(" - ")[1]
                                        payload.filters.equipment_name = itemCenter.split(" - ")[0]
                                    } else {
                                        payload.pipeline.push({
                                            "type": "insert_series",
                                            "name": itemCenter,
                                        })
                                    }
                                    first = false
                                }
                            }
                        } else {
                            let itemCenterShell = item.split('[')[1].split(']')[0]
                            let itemCenter = itemCenterShell.split('"')[1]
                            if (itemCenter) {
                                if (first) {
                                    payload.filters.sensor_name = itemCenter.split(" - ")[1]
                                    payload.filters.equipment_name = itemCenter.split(" - ")[0]
                                } else {
                                    payload.pipeline.push({
                                        "type": "insert_series",
                                        "name": itemCenter,
                                    })
                                }
                                first = false
                            }
                        }
                    }
                }
                if (!first) {
                    payload.pipeline.push({
                        "type": "calculate",
                        "name": "Calculated",
                        "formula": this.activeItem.calculations_statement,
                        "remove_others": false
                    })
                    this.calcPayload = [payload]
                    this.testCalculation = true
                } else {
                    payload.filters.equipment_name = this.activeItem.equipment_name
                    payload.pipeline.push({
                        "type": "calculate",
                        "name": "Calculated",
                        "formula": this.activeItem.calculations_statement,
                        "remove_others": false
                    })
                    this.calcPayload = [payload]
                    this.testCalculation = true
                }

            }

        },
        addSelectedSensor() {
            if (!this.activeItem.calculations_statement) {
                this.activeItem.calculations_statement = ""
            }
            this.activeItem.calculations_statement = this.activeItem.calculations_statement + 'df["' + this.selectedSensor + '"]'
            this.secondaryDialog = false
            this.selectedSensor = null
        },
        initializeVar(close) {
            this.error = null
            this.testCalculation = false
            this.faultyInitialState = false
            this.faultyNote = null
            this.activeItem = {
                sensor_id: null,
                connector_id: null,
                sensor_name: '',
                sensor_name_abbr: '',
                sensor_desc: '',
                unit: '',
                haystack_id: '',
                faulty: false,
                weight: 1,
                equipment_name: '',
                meta: '',
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            }
            if (close) {
                this.dialog = false;
            }
        },
        async addRecord(close) {
            this.error = null
            let newItem = JSON.parse(JSON.stringify(this.activeItem))
            if (newItem.calculations_statement && newItem.calculations_statement !== "") {
                newItem.haystack_id = null
                newItem.connector_id = null
                let tbr = newItem.calculations_statement.match(/df\[(.*?)\]/g)
                if (tbr) {
                    for (let item of tbr) {
                        if (item.includes("get_ids_by_ref")) {
                            let itemCenter = item.split('"')[1]
                            if (itemCenter) {
                                let equipName = itemCenter.split(" - ")[0]
                                if (this.$store.state.pointsListStore.pointsList.equipment_details[equipName]) {
                                    newItem.calculations_statement = newItem.calculations_statement.replace('"' + itemCenter + '"', this.$store.state.pointsListStore.pointsList.equipment_details[equipName].equipment_id)
                                } else {
                                    this.error = "No equipment found for " + equipName;
                                    return
                                }
                            }
                        } else if (item.startsWith('df[[')) {
                            let itemCenters = item.split('[[')[1].split(']')[0].split(',')
                            let newCenters = []
                            for (let itemCenterShell of itemCenters) {
                                let itemCenter = itemCenterShell.split('"')[1]
                                let foundItems = this.sensorList.filter(x => x.name === itemCenter)
                                if (foundItems.length < 1) {
                                    this.error = "No sensor found for " + itemCenter;
                                    return
                                } else {
                                    newCenters.push(foundItems[0].id)
                                }
                            }
                            if (itemCenters.length === newCenters.length) {
                                newItem.calculations_statement = newItem.calculations_statement.replace(item, 'df[[' + newCenters.join(',') + ']')
                            }
                        } else {
                            let itemCenterShell = item.split('[')[1].split(']')[0]
                            let itemCenter = itemCenterShell.split('"')[1]
                            if (itemCenter) {
                                let foundItems = this.sensorList.filter(x => x.name === itemCenter)
                                if (foundItems.length < 1) {
                                    this.error = "No sensor found for " + itemCenter;
                                    return
                                }
                                newItem.calculations_statement = newItem.calculations_statement.replace(item, 'df[' + foundItems[0].id + ']')
                            }
                        }

                    }
                }
                for (let sensor of this.sensorList) {
                    if (newItem.calculations_statement.includes(sensor.name)) {
                        this.error = "Could not handle " + sensor.name + " in automated replacement. Make sure the array containing this name starts with df[ or df[[";
                        return
                    }
                }
            }
            await putPoint(
                {
                    'sensor_id': newItem.sensor_id,
                    'sensor_name': newItem.sensor_name,
                    'sensor_name_abbr': newItem.sensor_name_abbr,
                    'sensor_desc': newItem.sensor_desc,
                    'unit': newItem.unit,
                    'faulty': newItem.faulty,
                    'weight': newItem.weight,
                    'haystack_id': newItem.haystack_id && newItem.haystack_id !== "" && newItem.haystack_id !== "null" && newItem.haystack_id !== "NaN" ? newItem.haystack_id : null,
                    'connector_id': newItem.connector_id && newItem.connector_id !== "" && newItem.connector_id !== "null" && newItem.connector_id !== "NaN" ? newItem.connector_id : null,
                    'facility_name': newItem.facility_name,
                    'equipment_name': newItem.equipment_name,
                    'meta': newItem.meta && newItem.meta !== "" ? JSON.parse(newItem.meta) : newItem.meta,
                    'calculations_statement': newItem.calculations_statement ? newItem.calculations_statement : null,
                }
            )
            if (newItem.sensor_id&&newItem.faulty!==this.faultyInitialState){
                this.$store.dispatch('logEvent', {type:'sensor.faultyStateChange',data:{sensor_id:newItem.sensor_id,faulty:newItem.faulty,note:this.faultyNote,time:moment().format('YYYY-MM-DD HH:mm:ss')}})
            }
            this.$emit('reloadpoints', this.dialog)
            if (close) {
                this.dialog = false;
            }
        }
    },
    name: 'PointRecordDialog'
}
</script>

<style scoped>

</style>
